/**
 * A length of time in words, for the two places that describe how long trusting
 * a device lasts (issue #16) — the tickbox on the sign-in screen and the
 * two-step section on `/profile`.
 *
 * Both take the number from the API rather than knowing it, so the sentence
 * cannot drift from the cookie it describes. Saying it in words is the other
 * half of that: "365 days" is a number to skim past, and the tickbox arrives
 * already ticked, so what somebody is agreeing to has to be a length they can
 * weigh against the computer in front of them.
 */
export function describeDays(days: number): string {
  if (days >= 365) return days < 730 ? 'a year' : `${Math.round(days / 365)} years`
  if (days >= 60) return `${Math.round(days / 30)} months`

  return `${days} days`
}
